import { omitBy } from 'es-toolkit';

export function omitNullish<T extends Record<string, unknown>>(obj: T) {
  return omitBy(obj, (value) => value == null) as Record<string, NonNullable<T[keyof T]>>;
}
